<template>
  <v-app :dark="dark">
    <AsideMenu v-if="profile !== null"></AsideMenu>
    <ToolbarMenu v-if="profile !== null"></ToolbarMenu>
    <v-content app>
      <router-view/>
    </v-content>
    <snackbars></snackbars>
    <Confirmation></Confirmation>
  </v-app>
</template>

<script>
import Snackbars from '@/components/Snackbars'
import AsideMenu from '@/components/AsideMenu'
import ToolbarMenu from '@/components/ToolbarMenu'
import Confirmation from '@/components/Confirmation'
export default {
  name: 'App',
  data: () => ({
    found: null
  }),
  components: { Snackbars, AsideMenu, ToolbarMenu, Confirmation },
  computed: {
    dark () {
      return false
    },
    ready () {
      return this.$store.state.ready
    },
    profile () {
      return this.$store.state.profile
    },
  },
  watch: {
    ready (val) {
      if (val === true && this.profile === null) {
        this.$router.push('login')
      }
    },
  }
}
</script>
<style>
</style>
